import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { navLinks } from '../mock/mock';
import emblem from '../assets/nk_emblem.png';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#fbf3e2]/90 backdrop-blur-md shadow-[0_4px_30px_rgba(124,19,15,0.12)] py-2'
          : 'bg-transparent py-4'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between">
        {/* Brand */}
        <button onClick={() => scrollTo('home')} className="flex items-center gap-3 group">
          <div
            className="w-11 h-11 rounded-full flex items-center justify-center transition-transform duration-500 group-hover:rotate-[20deg] group-hover:scale-105"
          >
            <img
              src={emblem}
              alt="Numerology King"
              className="w-full h-full object-contain drop-shadow-[0_2px_4px_rgba(90,13,10,0.3)]"
              draggable={false}
            />
          </div>
          <div className="text-left leading-none">
            <span className="font-display font-bold text-[#7c130f] text-lg tracking-wide">
              Numerology King
            </span>
            <span className="block font-heading font-bold text-[10px] tracking-[0.25em] text-[#a4761b]">
              BY VIVECHAN GAUTAM
            </span>
          </div>
        </button>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((l) => (
            <button
              key={l.to}
              onClick={() => scrollTo(l.to)}
              className="font-heading text-[13px] tracking-[0.15em] uppercase text-[#5a3a1c] hover:text-[#a71c14] transition-colors relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-[#c9962e] transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>

        <button
          onClick={() => scrollTo('booking')}
          className="hidden lg:flex items-center gap-2 px-5 py-2 rounded-full font-heading text-sm tracking-wide text-[#fff8e7] transition-all duration-300 hover:scale-105"
          style={{
            background: 'linear-gradient(90deg, #a71c14, #7c130f)',
            border: '1.5px solid #d9a63b',
            boxShadow: '0 4px 18px rgba(124,19,15,0.35)',
          }}
        >
          <Phone size={15} /> Book Now
        </button>

        {/* Mobile toggle */}
        <button
          className="lg:hidden text-[#7c130f]"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 ${
          open ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-[#fbf3e2]/95 backdrop-blur-md px-6 py-4 flex flex-col gap-3 border-t border-[#e2c887]">
          {navLinks.map((l) => (
            <button
              key={l.to}
              onClick={() => scrollTo(l.to)}
              className="font-heading text-left text-sm tracking-widest uppercase text-[#5a3a1c] hover:text-[#a71c14] py-1"
            >
              {l.label}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
}
